<template>
  <div class="calendar-row">
    <router-link class="areas-wrapper" :to="`/calendars/${calendar.id}`">
      <div class="icon-area">
        <CircleIcon kind="reservation" />
      </div>
      <div class="description-area">
        <div class="summary">
          <p class="text is-size-7 has-text-weight-bold">{{ summaryText }}</p>
        </div>
        <div class="detail">
          <p class="text is-size-8 has-text-weight-bold has-text-grey">{{ detailText }}</p>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
// @ is an alias to /src
import { defineComponent, computed } from '@vue/composition-api'
import moment from 'moment';

import CircleIcon from '@/components/shared/CircleIcon.vue'

export default defineComponent({
  name: 'CalendarRow',
  components: {
    CircleIcon,
  },
  props: {
    calendar: {
      type: Object,
      default: () => {},
    }
  },
  setup(props) {
    const summaryText = computed(() => props.calendar?.name)
    const detailText = computed(() => {
      return `作成した日時: ${moment(props.calendar?.createdAt).format("YYYY/MM/DD HH:mm")}`
    })

    return {
      summaryText,
      detailText,
    }
  },
})
</script>

<style lang="scss" scoped>
.calendar-row {
  height: 48px;
  width: 100%;
  display: flex;
  .areas-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    border-top: solid 1px colors(light-gray);
    > .icon-area {
      > .circle-icon {
        display: flex;
      }
    }
    > .description-area {
      width: calc(100% - 32px);
      padding-left: 8px;
      > .summary {
        width: 100%;
        height: 16px;
        display: flex;
        flex-direction: row;
        > .text {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: colors(dark-blue);
        }
      }
      > .detail {
        width: 100%;
        display: flex;
        flex-direction: row;
        > .text {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>